export const GOOGLE_CONNECTION_EXPIRED_ALERT =
  "Your Google connection has expired. The AI Agent won't work until you reconnect."
export const LIVE_DOCUMENTS_UNAVAILABLE_ALERT =
  "One or more knowledge base links are unavailable. The AI Agent won't work until you fix them."
export const LIVE_DOCUMENT_ACCESS_LOST_TOOLTIP =
  "Can't access this document. Fix it to keep your AI Agent running."
